import Component from './md-preview.vue';
export default Component;
